<template>
  <div v-if="isVisible" class="fixed inset-0 z-[9000] overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center">
      <!-- 背景遮罩 -->
      <div class="fixed inset-0 transition-opacity" @click="close">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- 弹窗内容 -->
      <div class="relative inline-block w-full p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg" :style="{ maxWidth: width }">
        <!-- 标题 -->
        <div v-if="title" class="mb-4">
          <h3 class="text-lg font-medium leading-6 text-gray-900">{{ title }}</h3>
        </div>
        
        <!-- 内容 -->
        <div>
          <slot></slot>
        </div>
        
        <!-- 底部 -->
        <div class="mt-4 bg-gray-50 -m-6 p-4" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '500px'
    }
  },
  emits: ['update:modelValue', 'update:visible'],
  computed: {
    isVisible() {
      return this.modelValue || this.visible
    }
  },
  methods: {
    close() {
      if (this.modelValue !== undefined) {
        this.$emit('update:modelValue', false)
      }
      if (this.visible !== undefined) {
        this.$emit('update:visible', false)
      }
    }
  }
}
</script>
